import { buildResponsiveSize } from '@tvg/fuse-utils';
import styled from 'styled-components';

const SizeStyleConfig = {
	large: {
		width: 'var(--spacing-global-space6)', // 24px
		height: 'var(--spacing-global-space6)',
	},
	medium: {
		width: 'calc(var(--spacing-global-space5) * 1.25)', // 20px
		height: 'calc(var(--spacing-global-space5) * 1.25)',
	},
	small: {
		width: 'var(--spacing-global-space5)', // 16px
		height: 'var(--spacing-global-space5)',
	},
};

const getVolumeByViewport = (swatchSize) => `
	width: ${SizeStyleConfig[swatchSize]?.width};
	height: ${SizeStyleConfig[swatchSize]?.height};
`;

const setVolume = (size) => {
	const [isResponsive, setViewportCss] = buildResponsiveSize(size);

	return isResponsive ? setViewportCss(getVolumeByViewport) : getVolumeByViewport(size);
};

const StyledSwatch = styled.span.attrs({
	className: 'fuse-swatch',
})`
	display: inline-block;
	${({ size }) => setVolume(size)}

	border-radius: 50%;
	border: var(--border-width-xs) solid var(--color-functional-tintBlack20);

	${({ imageSrc }) =>
		imageSrc &&
		`
			background-image: url('${imageSrc}');
			background-size: cover;
		`}

	${({ colour }) =>
		colour &&
		`
			background-color: ${colour};
		`}
`;

export default StyledSwatch;
